import { render, staticRenderFns } from "./HirePage.vue?vue&type=template&id=f4596a06"
import script from "./HirePage.vue?vue&type=script&lang=js"
export * from "./HirePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports